/**
 * Contenuto — coreBOS `cbContent` (85x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const contentDescriptor = {
    slug: 'cmp_content',
    kind: 'document',
    label: { singular: 'Contenuto', plural: 'Contenuti' },
    table: 'compliance_content',
    idStrategy: 'sha256',
    fields: [
        { name: 'title', type: 'text', label: 'Titolo', required: true },
        { name: 'position', type: 'text', label: 'Posizione' },
        { name: 'page', type: 'text', label: 'Pagina' },
        { name: 'cbcontent_no', type: 'text', label: 'Numero' },
        { name: 'allow_upload', type: 'boolean', label: 'Allow upload' },
        { name: 'content', type: 'text', label: 'Contenuto' },
        { name: 'description', type: 'text', label: 'Descrizione' },
    ],
    relations: [
        { name: 'contenttocontact', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'ReadOutlined', navGroup: 'Policy', markdown: ['content'] },
};
